import React, { useState } from 'react';
import { protectedResources } from 'config/msalConfig';
import execute from "hooks/execute";
import CustomerRoleHeader from './CustomerRoleHeader';
import CustomerRoleFilter from './CustomerRoleFilter';
import CustomerRoleTable from './CustomerRolesTable';

function CustomerRoleManager({ userDetails }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [organizationId, setOrganizationId] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [customerRoles, setCustomerRoles] = useState([]);
    const [availableModules, setAvailableModules] = useState([]);

    const fetchCustomerRoles = async (values) => {
        console.log("fetching Roles");

        try {
            setLoading(true);
            setError('');
            const response = await execute('GET', `${protectedResources.api.baseEndPoint}/customers/${values.customer_id}/customerRoles`);
            if (response) {
                if (response.success) {
                    setCustomerRoles(response.data);
                    setLoading(false);
                } else {
                    setCustomerRoles([]);
                    setError(response.message || 'No organization found for the specified name');
                    setLoading(false);
                }
            }
        } catch (err) {
            setCustomerRoles([]);
            setError('Failed to fetch data: ' + err.message);
            setLoading(false);
        }
    };

    const handleSearch = async (values) => {
        console.log("submitting///////");
        console.log(values);
        fetchCustomerRoles(values);
    };

    return (
        <div
            style={{
                width: "90%",
                marginLeft: "auto",
                marginRight: "auto",
                padding: "20px 0",
            }}
        >
            <CustomerRoleHeader />
            <CustomerRoleFilter
                setOrganizationId={setOrganizationId}
                setCustomerId={setCustomerId}
                handleSearch={handleSearch}
                setAvailableModules={setAvailableModules}
            />
            <CustomerRoleTable
                customerRoles={customerRoles}
                customerId={customerId}
                organizationId={organizationId}
                fetchCustomerRoles={fetchCustomerRoles}
                loading={loading}
                availableModules={availableModules}
            />
            {error ? <div style={{ color: "#d14343", marginTop: 8 }}>{error}</div> : null}
        </div>
    );
}

export default CustomerRoleManager;
